import {createMicrositeGatsbyWrapper} from 'microsites/core/chatMicrosite/gatsby/createMicrositeGatsbyWrapper';
import {DEFAULT_LANGUAGE_ID} from 'microsites/core/chatMicrosite/translations/utils/DEFAULT_LANGUAGE_ID';
import {languageSelectorTranslationDefinition} from './src/components/languageSelector/languageSelectorTranslationDef';
import {CHATCOFFEE_DEFAULT_LOCALE} from './src/components/localeLoaders';
import {ChatCoffeeMicrositeProvider} from './src/micrositeConfig';

const defaultLanguageSelectorTranslation = languageSelectorTranslationDefinition.syncLoaders[CHATCOFFEE_DEFAULT_LOCALE]();
const defaultLanguageSelectorEnglishTranslation = languageSelectorTranslationDefinition.syncLoaders[DEFAULT_LANGUAGE_ID]();

export const wrapRootElement = createMicrositeGatsbyWrapper(ChatCoffeeMicrositeProvider, CHATCOFFEE_DEFAULT_LOCALE, {
  languageSelectorTranslation: defaultLanguageSelectorTranslation,
  languageSelectorEnglishTranslation: defaultLanguageSelectorEnglishTranslation,
});
